import router from '@/router'


export default {
    GET_BANKS: state => {
        return state.banks.map(bank => {
            return {
                ...bank,
                interestRates: bank.interestRates.map(rate => +rate),
                low_co2: bank.low_co2.map(rate => +rate),
            }
        })
    },
    flagCarInStock() {
        return router.currentRoute.name == "CarInStock"
    },
    getFlokkar: (state, getters, rootState) => id => {
        return rootState.lib && rootState.lib.flokkar && rootState.lib.flokkar.find(e => e.id == id);
    }
}
